export default __webpack_public_path__ + "static/media/Icons_Marina_Grey Icon.28a8c133.svg";